import { FlowComponentDefinition } from "../../interface/functionalityInterface";
import { OUTLINE_COLOR, getTeeTransform } from "./renderingUtils";

export const tPipeComponent: FlowComponentDefinition = {
  type: "tPipe",
  title: "T-pipe",
  category: "Pipes & Fittings",
  visualKind: "tPipe",
  defaultColor: "#9ea4ab",
  previewFlow: { from: "down", to: "right" },
  ports: ["left", "right", "down"],
  incomingDirections: ["down"],
  outgoingDirections: ["left", "right"],
  defaults: { diameter: "100", branchDiameter: "100" },
  fields: [
    { key: "diameter", label: "Main diameter" },
    { key: "branchDiameter", label: "Branch diameter" },
    { key: "color", label: "Color", inputType: "color" },
  ],
  renderGraphic: ({ node, componentColor, arrowColor }) => (
    <g transform={getTeeTransform(node.flow.from)}>
      <rect x="0" y="40" width="100" height="20" rx="4" fill={componentColor} stroke={OUTLINE_COLOR} strokeWidth="2.2" />
      <rect x="40" y="40" width="20" height="60" rx="4" fill={componentColor} stroke={OUTLINE_COLOR} strokeWidth="2.2" />
      <line x1="14" y1="50" x2="86" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
      <line x1="50" y1="50" x2="50" y2="86" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
      <polygon points="16,50 28,44 28,56" fill={arrowColor} />
      <polygon points="84,50 72,44 72,56" fill={arrowColor} />
    </g>
  ),
  renderAnimatedFlow: ({ node, pulseColor }) => (
    <g transform={getTeeTransform(node.flow.from)}>
      <line x1="50" y1="92" x2="50" y2="50" stroke={pulseColor} strokeWidth="11" strokeLinecap="round" />
      <line x1="50" y1="50" x2="8" y2="50" stroke={pulseColor} strokeWidth="11" strokeLinecap="round" />
      <line x1="50" y1="50" x2="92" y2="50" stroke={pulseColor} strokeWidth="11" strokeLinecap="round" />
    </g>
  ),
};
